var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"imgg",staticClass:"xm"},[_c('div',{staticClass:"fd"}),_c('img',{ref:"src",attrs:{"src":_vm.src,"alt":"","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }